import axiosInstance from "../Interceptor";

export const getCustomerAddressApi = (payload) => {
  return axiosInstance
    .get(`user-service/api/v1/customer/profile/${payload}/`)

    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
